export default __webpack_public_path__ + "bf65b4c3a01f65fee8a2cad6d03a5be7.svg";